export default __webpack_public_path__ + "static/color-picker-agnostic-color-light-760d19336cc933ec7c92caac1c997c7ee1d7acf653c552eb0b1248ce5c688baf.png";